import { VpChevronLeftIcon } from '@vtmn-play/icons/react';
import { VpButtonProps, VpIconButton } from '@vtmn-play/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './goBackLink.scss';

export type GoBackLinkProps = VpButtonProps & {
  path: string;
};

export default ({ path }: GoBackLinkProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="my-sm-breadcrumb">
      <VpIconButton
        onClick={() => navigate(path)}
        variant="secondary"
        size="small"
        aria-label="Go back on previous page"
        data-testid="go-back_link"
      >
        <VpChevronLeftIcon />
      </VpIconButton>
      <span className="my-sm-breadcrumb-title">
        {t('personal-offer.title')}
      </span>
    </div>
  );
};
